import { useDocumentResolverContext } from '../contexts/DocumentResolverContext/hooks/useDocumentResolverContext.hook';
import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useDocTitre = ({
  enabled,
}: Readonly<ResolverParameters>): ResolverResult<string> => {
  const { printerSettings } = useDocumentResolverContext();

  if (!enabled) {
    return {
      data: undefined,
      error: null,
      isSuccess: false,
      isLoading: false,
    };
  }

  return {
    data: { generated: printerSettings?.title ?? 'Aucun titre spécifié' },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
